export const CALDAV_ALLOWED_EMAIL_DOMAIN = '@ktsstudio.ru';

export const CALDAV_SERVER_URL = 'calendar.mail.ru';
